export default {"src":"/_next/static/media/icon-social-twitter-white.f4745db2.svg","height":23,"width":28,"blurWidth":0,"blurHeight":0};